import { AWRecentlySearchedEntity } from '@blk/awt-userpreference';
import { AxiosResponse } from 'axios';
import { SearchEntity } from '../../tempModels';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { userPreferenceApi } from './Base';

export async function getRecentSearches(pkg?: string): Promise<AxiosResponse<AWRecentlySearchedEntity[]>> {
  const path = '/v1/recent-searches';
  const response = await userPreferenceApi.get<AGraphWrappedType<AWRecentlySearchedEntity[], 'entities'>>(path, {
    params: { pkg },
  });
  return unwrapAGraphResponse(response, 'entities');
}

export const postRecentlySearchedEntity = async (recentlySearchedEntity: SearchEntity, pkg: string) => {
  const path = `/v1/recent-searches`;
  const response = await userPreferenceApi.post<AGraphWrappedType<string, 'id'>>(path, recentlySearchedEntity, {
    params: { pkg },
  });
  return unwrapAGraphResponse(response, 'id');
};

export const deleteRecentlySearchedEntity = (id: string, pkg: string) => {
  const path = `v1/recent-searches/${id}`;
  return userPreferenceApi.delete(path, { params: { pkg } });
};
